import { render, staticRenderFns } from "./SelectUmsUser.vue?vue&type=template&id=eaba3c66"
import script from "./SelectUmsUser.vue?vue&type=script&lang=js"
export * from "./SelectUmsUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports